import {
  ChangeDetectorRef,
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Employee } from '../../model/employee/employee';
import { MatDialog } from '@angular/material/dialog';
import { EditDepartmentDialogComponent } from '../dialogs/edit-department-dialog/edit-department-dialog.component';
import { DepartmentOption } from '../../model/employee/department';

@Component({
  selector: 'app-personal-information-department',
  templateUrl: './personal-information-department.component.html',
  styleUrls: ['./personal-information-department.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PersonalInformationDepartmentComponent {
  @Input() employee: Employee | null = null;

  constructor(
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  onChangeDepartment() {
    if (!this.employee) {
      return;
    }

    const dialogRef = this.dialog.open(EditDepartmentDialogComponent, {
      data: this.employee,
      minWidth: '25rem',
    });

    dialogRef.afterClosed().subscribe((result: Employee) => {
      if (result) {
        this.employee = result;
        this.cdr.markForCheck();
      }
    });
  }

  protected readonly DepartmentOption = DepartmentOption;
}
